import { RecaptchaLibToken, RecaptchaLibVersion } from '@/libs/recaptcha-lib/types/types';
import { paymentsApi } from '.';

export interface BraintreeCreateRequest {
  client: string,
  order_reference: string,
  amount: number,
  currency: string,
  giftaid: number,
  firstName: string,
  lastName: string,
  email: string,
  address1: string,
  address2: string,
  address3: string,
  town: string,
  postcode: string,
  country: string,
  campaign: string,
  transSource: string,
  transSourceUrl: string,
  transType: string,
  recaptcha_token: RecaptchaLibToken,
  recaptcha_version: RecaptchaLibVersion,
  cartId?: string,
  paymentType?: 'GOOGLEPAY' | 'APPLEPAY', // Only set for Googlepay/Applepay
  paymentMethod?: unknown, // Only set for Googlepay/Applepay
  transactionId?: string, // Only set on "direct payment" journey
}

export interface BraintreeCreateData {
  account_identifier: string,
  transactionId: string,
  token: string,
}

export interface BraintreeCreateResponse {
  data: BraintreeCreateData,
  message: string,
}

const extendedPaymentsApi = paymentsApi.injectEndpoints({
  endpoints: builder => ({
    braintreeCreate: builder.mutation<BraintreeCreateResponse, BraintreeCreateRequest>({
      query: body => ({
        url: 'provider/braintree/create',
        method: 'POST',
        body,
      })
    })
  })
});

export const { useBraintreeCreateMutation } = extendedPaymentsApi;
